// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"aa037852","335":"ab4e9eed","548":"26c96070","665":"b0b90e14","682":"f8090cea","764":"f41f425e","843":"6438c313"}[chunkId] + ".chunk.js";
};